/* DirectBlanks Drop — popup, Plinko, floating ticket. Settings live in the "DirectBlanks Drop" section (Customize > Footer). */
(function () {
  'use strict';
  var cfgEl = document.getElementById('db-drop-config');
  if (!cfgEl) return;
  var C;
  try { C = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (window.__dbDropInit) return; window.__dbDropInit = true;

  // ---------- sticky Add to Cart bar helpers (also used to tuck away small floating buttons that cover it) ----------
  function stickyBars() {
    var out = [];
    String(C.stickySelector || '').split(',').forEach(function (sel) { sel = sel.trim(); if (!sel) return; try { document.querySelectorAll(sel).forEach(function (b) { out.push(b); }); } catch (e) {} });
    return out;
  }
  function barShown(bar) {
    var cs = getComputedStyle(bar);
    if (cs.display === 'none' || cs.visibility === 'hidden') return false; // opacity is ignored on purpose: the bar fades in
    if (cs.position !== 'fixed' && cs.position !== 'sticky') return false;
    var b = parseFloat(cs.bottom); return !isNaN(b) && b < 8 && bar.offsetHeight > 0;
  }
  var tucked = [];
  function tuck() {
    if (!C.tuckFloaters) return;
    var shown = stickyBars().filter(barShown);
    if (!shown.length) { tucked.forEach(function (el) { el.classList.remove('dbd-tucked'); }); tucked = []; return; }
    var ours = document.getElementById('db-drop-root');
    shown.forEach(function (bar) {
      var top = innerHeight - bar.offsetHeight;
      for (var x = 20; x < innerWidth; x += 40) for (var j = 0; j < 4; j++) {
        var els = document.elementsFromPoint(x, top + 6 + (bar.offsetHeight - 12) * j / 3);
        for (var k = 0; k < els.length; k++) {
          var el = els[k];
          if (ours && ours.contains(el)) continue;
          if (bar.contains(el)) break;
          for (var n = el; n && n !== document.body && n !== document.documentElement; n = n.parentElement) {
            if (getComputedStyle(n).position !== 'fixed') continue;
            var r = n.getBoundingClientRect();
            if (n !== bar && !n.contains(bar) && r.width < innerWidth * 0.5 && r.height < 220) { n.classList.add('dbd-tucked'); if (tucked.indexOf(n) < 0) tucked.push(n); }
            break;
          }
          break;
        }
      }
    });
  }
  var tuckRaf = 0, tuckFollow = 0; function queueTuck() { clearTimeout(tuckFollow); tuckFollow = setTimeout(tuck, 90); if (tuckRaf) return; tuckRaf = requestAnimationFrame(function () { tuckRaf = 0; tuck(); }); }
  document.addEventListener('transitionrun', queueTuck, true);
  addEventListener('scroll', queueTuck, { passive: true }); addEventListener('resize', queueTuck);
  document.addEventListener('transitionend', queueTuck, true);
  setInterval(tuck, 1500);

  var DESIGN = !!C.designMode, PREVIEW = DESIGN ? (C.preview || 'off') : 'off';
  if (!C.enabled && PREVIEW === 'off') return;

  // ---------- helpers ----------
  var KEY = 'dbDrop:v1';
  function load() { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; } }
  function save() { if (DESIGN) return; try { localStorage.setItem(KEY, JSON.stringify(S)); } catch (e) {} }
  var S = DESIGN ? {} : load();
  var DAY = 864e5;
  function $(sel, root) { return (root || document).querySelector(sel); }
  function money(n) { return '$' + (Math.round(n * 100) / 100).toFixed(2).replace(/\.00$/, ''); }
  function moneyExact(n) { return '$' + (Math.round(n * 100) / 100).toFixed(2); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function fill(tpl, v) { return String(tpl || '').replace(/\{(\w+)\}/g, function (m, k) { return v[k] != null ? v[k] : m; }); }
  function reduceMotion() { return window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches; }

  // ---------- offers ----------
  var OFFERS = {
    first: { tiers: [[C.l1Min, C.l1Amt, C.l1Code], [C.l2Min, C.l2Amt, C.l2Code]].filter(function (t) { return t[0] > 0 && t[1] > 0 && t[2]; }) },
    r1: { tiers: [[C.r1Min, C.r1Amt, C.r1Code]] },
    r2: { tiers: [[C.r2Min, C.r2Amt, C.r2Code]] }
  };
  function O(k) { return OFFERS[k] || OFFERS.first; }
  function top(o) { return o.tiers[o.tiers.length - 1][1]; }
  function unlocked(o, sub) { var r = null; o.tiers.forEach(function (t) { if (sub >= t[0]) r = t; }); return r; }
  function nextTier(o, sub) { for (var i = 0; i < o.tiers.length; i++) if (sub < o.tiers[i][0]) return o.tiers[i]; return null; }
  function label(o) { return o.tiers.map(function (t) { return money(t[1]) + ' off ' + money(t[0]) + '+'; }).join(', '); }
  function disp(o) { return (o.tiers.length > 1 ? 'up to ' : '') + money(top(o)) + ' off'; }
  var UNIQUE = !!C.l1Unique, PREFIX = String(C.l1Prefix || '').toUpperCase();
  function isMine(c) { return ALL_CODES.indexOf(c) > -1 || (UNIQUE && PREFIX && c.indexOf(PREFIX) === 0); }
  // Level 1 of the first-order offer can be a per-person Klaviyo code (picked up from the cart once applied).
  function codeFor(t) { if (UNIQUE && S.offer === 'first' && t === OFFERS.first.tiers[0]) return S.uniqueCode || null; return String(t[2]).toUpperCase(); }
  var ALL_CODES = [];
  Object.keys(OFFERS).forEach(function (k) { OFFERS[k].tiers.forEach(function (t) { ALL_CODES.push(String(t[2]).toUpperCase()); }); });

  // ---------- who is this ----------
  var cust = C.customer || {};
  var tags = (cust.tags || []).map(function (t) { return String(t).toLowerCase(); });
  var wsTags = String(C.wholesaleTags || '').toLowerCase().split(',').map(function (t) { return t.trim(); }).filter(Boolean);
  var isWholesale = tags.some(function (t) { return t.indexOf('wholesal') > -1 || wsTags.indexOf(t) > -1; });
  if (isWholesale && PREVIEW === 'off') return;
  var isReturning = (cust.ordersCount || 0) > 0;
  var excluded = String(C.excludedTemplates || '').split(',').map(function (t) { return t.trim(); }).filter(Boolean);
  var tpl = String(C.template || '');
  var onExcluded = excluded.some(function (t) { return tpl.indexOf(t) === 0; });
  var isProduct = tpl.indexOf('product') === 0, isCartPage = tpl.indexOf('cart') === 0;

  // ---------- Klaviyo (client API, public key only) ----------
  var KL = 'https://a.klaviyo.com/client/';
  function kl(path, body) {
    if (DESIGN || !C.klaviyoKey) return Promise.resolve();
    return fetch(KL + path + '?company_id=' + encodeURIComponent(C.klaviyoKey), {
      method: 'POST', headers: { 'Content-Type': 'application/vnd.api+json', revision: '2025-01-15' }, body: JSON.stringify(body)
    }).catch(function () {});
  }
  function klSubscribe(email, phone) {
    var subs = {}; if (email) subs.email = { marketing: { consent: 'SUBSCRIBED' } }; if (phone) subs.sms = { marketing: { consent: 'SUBSCRIBED' } };
    var attrs = { subscriptions: subs }; if (email) attrs.email = email; if (phone) attrs.phone_number = phone;
    return kl('subscriptions', { data: { type: 'subscription', attributes: { custom_source: 'DirectBlanks Drop popup', profile: { data: { type: 'profile', attributes: attrs } } }, relationships: { list: { data: { type: 'list', id: C.klaviyoList } } } } });
  }
  function klProfile(email, props) { return kl('profiles', { data: { type: 'profile', attributes: { email: email, properties: props } } }); }
  function klEvent(name, email, props) {
    if (!email) return Promise.resolve();
    return kl('events', { data: { type: 'event', attributes: { properties: props || {}, metric: { data: { type: 'metric', attributes: { name: name } } }, profile: { data: { type: 'profile', attributes: { email: email } } } } } });
  }
  function klaviyoKnown() {
    try { var m = document.cookie.match(/__kla_id=([^;]+)/); if (!m) return false; var d = JSON.parse(atob(decodeURIComponent(m[1]))); return !!(d.$email || d.$phone_number || d.$exchange_id); } catch (e) { return false; }
  }

  // ---------- cart ----------
  var cart = { sub: 0, codes: [], count: 0 }, selfUpdate = 0;
  function readCart(c) {
    if (!c) return;
    cart.sub = (c.items_subtotal_price != null ? c.items_subtotal_price : c.total_price || 0) / 100;
    cart.count = c.item_count || 0;
    cart.codes = (c.discount_codes || []).map(function (d) { return String(d.code).toUpperCase(); });
    if (UNIQUE && PREFIX && !DESIGN) {
      var uc = cart.codes.filter(function (x) { return x.indexOf(PREFIX) === 0; })[0];
      if (uc && S.uniqueCode !== uc) {
        S.uniqueCode = uc;
        if (!S.claimed) { S.claimed = true; S.claimedAt = Date.now(); S.offer = 'first'; S.stage = 'reveal'; }
        save();
      }
    }
  }
  var refreshTimer;
  function refreshCart() {
    if (DESIGN) return Promise.resolve();
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { readCart(c); onCart(); }).catch(function () {});
  }
  function queueRefresh() { clearTimeout(refreshTimer); refreshTimer = setTimeout(refreshCart, 150); }
  if (!DESIGN) {
    document.addEventListener('cart:update', queueRefresh);
    document.addEventListener('discount:update', queueRefresh);
    var _fetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = _fetch.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)/.test(url) && !selfUpdate) p.then(function () { queueRefresh(); }).catch(function () {});
      return p;
    };
  }
  function desiredCode() {
    if (!S.claimed) return null;
    var o = O(S.offer), u = unlocked(o, cart.sub);
    return codeFor(u || o.tiers[0]);
  }
  function syncCode() {
    if (DESIGN || !S.claimed || !C.autoApply) return;
    var want = desiredCode(); if (!want) return;
    var others = cart.codes.filter(function (c) { return !isMine(c); });
    var mine = cart.codes.filter(isMine);
    if (mine.length === 1 && mine[0] === want) return;
    selfUpdate++;
    fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: others.concat([want]).join(',') }) })
      .then(function (r) { return r.json(); }).then(function (c) { readCart(c); }).catch(function () {})
      .then(function () { selfUpdate--; render(); });
  }

  // ---------- root + styles hooks ----------
  var root = document.createElement('div'); root.className = 'dbd'; root.id = 'db-drop-root';
  document.body.appendChild(root);
  var floatEl = document.createElement('div'); floatEl.className = 'dbd-float'; root.appendChild(floatEl);
  var pop = null, step = null, hold = false, skipShown = false, skipTimer = null, drawerOpen = false, justUnlocked = false, lastLevel = null;
  var stuck = false, peek = false, forceStuck = false; // stuck: a sticky Add to Cart bar is showing; peek: they tapped the small card to see the full ticket
  function setKlaviyoHidden(on) { document.documentElement.classList.toggle('dbd-hide-kl', !!(on && C.hideKlaviyo)); }

  // ---------- Plinko ----------
  var SLOTS = String(C.slots || '').split(',').map(function (s) { return parseFloat(s); }).filter(function (n) { return !isNaN(n); });
  if (SLOTS.length !== 7) SLOTS = [25, 15, 10, 40, 10, 15, 25];
  var tierColors = (function () {
    var uniq = SLOTS.slice().sort(function (a, b) { return a - b; }).filter(function (v, i, a) { return a.indexOf(v) === i; });
    var pal = [C.slotColor1, C.slotColor2, C.slotColor3, C.slotColor4];
    var map = {}; uniq.forEach(function (v, i) { map[v] = pal[Math.min(i, 3)] || '#CBDEE8'; }); return map;
  })();
  function lum(hex) { hex = String(hex).replace('#', ''); if (hex.length === 3) hex = hex.split('').map(function (c) { return c + c; }).join(''); var r = parseInt(hex.substr(0, 2), 16), g = parseInt(hex.substr(2, 2), 16), b = parseInt(hex.substr(4, 2), 16); return (0.299 * r + 0.587 * g + 0.114 * b) / 255; }
  function lighten(hex, a) { hex = String(hex).replace('#', ''); if (hex.length === 3) hex = hex.split('').map(function (c) { return c + c; }).join(''); var o = [0, 2, 4].map(function (i) { var v = parseInt(hex.substr(i, 2), 16); return Math.round(v + (255 - v) * a); }); return 'rgb(' + o.join(',') + ')'; }
  var board = {
    W: 320, H: 262, s: 36, rows: 6, ctx: null, ball: null, hit: {}, win: -1,
    init: function (c) { var d = 2; c.width = this.W * d; c.height = this.H * d; this.ctx = c.getContext('2d'); this.ctx.setTransform(d, 0, 0, d, 0, 0); this.ball = null; this.hit = {}; this.win = -1; },
    pegY: function (k) { return 44 + k * 28; },
    rr: function (x, y, w, h, r) { var c = this.ctx; c.beginPath(); if (c.roundRect) c.roundRect(x, y, w, h, r); else c.rect(x, y, w, h); },
    draw: function () {
      var ctx = this.ctx, W = this.W, s = this.s, cx = W / 2, self = this; if (!ctx) return;
      ctx.clearRect(0, 0, W, this.H);
      ctx.fillStyle = C.pegColor; this.rr(cx - 16, 10, 32, 10, 5); ctx.fill();
      for (var k = 0; k < this.rows; k++) for (var i = 0; i < k + 3; i++) {
        var x = cx + (i - (k + 2) / 2) * s, y = this.pegY(k), on = this.hit[k + ':' + i];
        ctx.fillStyle = on ? C.accent : C.pegColor; ctx.beginPath(); ctx.arc(x, y, on ? 4.5 : 3.5, 0, Math.PI * 2); ctx.fill();
      }
      var by = this.pegY(this.rows - 1) + 26;
      SLOTS.forEach(function (v, j) {
        var x = cx + (j - 3) * s, w = s - 4, win = j === self.win, col = tierColors[v], y = by - (win ? 4 : 0), h = 44;
        if (win) { ctx.save(); ctx.shadowColor = 'rgba(0,0,0,.35)'; ctx.shadowBlur = 14; ctx.fillStyle = '#fff'; self.rr(x - w / 2 - 2, y - 2, w + 4, h + 4, [8, 8, 11, 11]); ctx.fill(); ctx.restore(); }
        var g = ctx.createLinearGradient(0, y, 0, y + h); g.addColorStop(0, lighten(col, 0.45)); g.addColorStop(1, col);
        ctx.fillStyle = g; self.rr(x - w / 2, y, w, h, [6, 6, 9, 9]); ctx.fill();
        ctx.fillStyle = 'rgba(255,255,255,.35)'; self.rr(x - w / 2 + 3, y + 3, w - 6, 6, 3); ctx.fill();
        if (win) { ctx.strokeStyle = C.ink; ctx.lineWidth = 1.5; self.rr(x - w / 2, y, w, h, [6, 6, 9, 9]); ctx.stroke(); }
        ctx.fillStyle = lum(col) > 0.55 ? C.ink : '#FFFFFF'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
        ctx.font = '700 13px ' + C.bodyFont; ctx.fillText('$' + v, x, y + 19);
        ctx.font = '700 8px ' + C.bodyFont; ctx.fillText('OFF', x, y + 33);
      });
      if (this.ball) { ctx.fillStyle = C.ink; ctx.beginPath(); ctx.arc(this.ball.x, this.ball.y, 7, 0, Math.PI * 2); ctx.fill(); }
    },
    play: function (target, done) {
      var self = this, W = this.W, s = this.s, rows = this.rows, cx = W / 2;
      var dirs = []; for (var i = 0; i < rows; i++) dirs.push(i < target ? 1 : 0); dirs.sort(function () { return Math.random() - 0.5; });
      var pts = [{ x: cx, y: 18 }], R = 0;
      for (var k = 0; k < rows; k++) { pts.push({ x: cx + (R - k / 2) * s, y: this.pegY(k) - 10, peg: k + ':' + (R + 1) }); R += dirs[k]; }
      pts.push({ x: cx + (R - 3) * s, y: this.pegY(rows - 1) + 16 });
      var seg = reduceMotion() ? 40 : (C.ballSpeed || 290), idx = 0, start = null;
      function tick(t) {
        if (start === null) start = t;
        var a = pts[idx], b = pts[idx + 1], u = Math.min(1, (t - start) / seg), e = u * u * (3 - 2 * u), hop = (idx === 0 || idx === pts.length - 2) ? 0 : 12;
        self.ball = { x: a.x + (b.x - a.x) * e, y: a.y + (b.y - a.y) * u - hop * 4 * u * (1 - u) }; self.draw();
        if (u >= 1) { if (b.peg) self.hit[b.peg] = 1; idx++; start = t; if (idx >= pts.length - 1) { self.win = R; self.ball = null; self.draw(); return done(); } }
        requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }
  };

  // ---------- popup ----------
  function logo() { return C.logoUrl ? '<img src="' + esc(C.logoUrl) + '" alt="' + esc(C.shopName) + '" style="height:' + (C.logoHeight || 26) + 'px">' : '<span>' + esc(C.shopName) + '</span>'; }
  function vars() { var o = O(S.offer || 'first'), t1 = o.tiers[0]; return { offer: disp(o), terms: label(o), amount: money(t1[1]), min: money(t1[0]), top: money(top(o)) }; }
  function openPop(at) {
    if (pop) return;
    pop = document.createElement('div'); pop.className = 'dbd-pop'; pop.setAttribute('role', 'dialog'); pop.setAttribute('aria-modal', 'true'); pop.setAttribute('aria-labelledby', 'dbd-h');
    pop.innerHTML = '<div class="dbd-backdrop"></div><div class="dbd-sheet"><button class="dbd-x" type="button" aria-label="Close">×</button><div class="dbd-step"></div></div>';
    root.appendChild(pop); step = $('.dbd-step', pop);
    $('.dbd-x', pop).addEventListener('click', onClose);
    $('.dbd-backdrop', pop).addEventListener('click', onClose);
    pop.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); onClose(); }
      if (e.key === 'Tab') { var f = pop.querySelectorAll('button:not([hidden]),input,a[href]'); f = Array.prototype.filter.call(f, function (el) { return el.offsetParent !== null; }); if (!f.length) return; var first = f[0], last = f[f.length - 1]; if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); } else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); } }
    });
    document.documentElement.classList.add('dbd-lock');
    setKlaviyoHidden(true);
    S.stage = at || S.stage || 'teaser'; renderStep(); renderFloat();
  }
  function closePop() { if (!pop) return; if (!S.claimed) { S.closedAt = Date.now(); save(); } clearTimeout(skipTimer); pop.remove(); pop = null; step = null; hold = false; document.documentElement.classList.remove('dbd-lock'); if (!S.claimed) setKlaviyoHidden(false); renderFloat(); }
  function onClose() {
    if (S.stage === 'sms' && !hold && C.smsEnabled) { hold = true; renderStep(); return; }
    if (S.stage === 'teaser') { S.teaserClosedAt = Date.now(); }
    save(); closePop();
  }
  function btn(id, text, cls) { return '<button class="dbd-btn ' + (cls || '') + '" id="' + id + '" type="button">' + esc(text) + '</button>'; }
  function renderStep() {
    if (!step) return;
    var v = vars(), o = O(S.offer || 'first'), ret = S.offer === 'r1' || S.offer === 'r2' || (!S.offer && isReturning);
    var head = '<div class="dbd-logo">' + logo() + '</div>';
    if (S.stage === 'teaser') {
      step.innerHTML = head + '<h2 class="dbd-h" id="dbd-h">' + esc(C.tTeaserHead) + '</h2><p class="dbd-kick">' + esc(ret ? C.tTeaserKickReturning : C.tTeaserKick) + '</p>' +
        '<canvas class="dbd-board" aria-label="Prize board: ' + SLOTS.map(function (s) { return '$' + s + ' off'; }).join(', ') + '"></canvas>' + btn('dbd-go', C.tTeaserBtn);
      board.init($('.dbd-board', step)); board.draw();
      $('#dbd-go').addEventListener('click', drop);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { board.draw(); });
    } else if (S.stage === 'email') {
      var kick = o.tiers.length > 1 ? label(o) : (ret ? C.tNextOrder : C.tFirstOrder) + ' ' + money(o.tiers[0][0]) + '+';
      step.innerHTML = head + '<h2 class="dbd-h dbd-two" id="dbd-h">' + fill(esc(C.tEmailHead), { offer: '<span class="dbd-amt">' + esc(v.offer) + '</span>' }) + '</h2><p class="dbd-kick">' + esc(kick) + '</p>' +
        '<form class="dbd-form" novalidate><div class="dbd-field"><input id="dbd-email" type="email" inputmode="email" autocomplete="email" placeholder="' + esc(C.tEmailPh) + '" aria-label="Email address" value="' + esc(S.email || cust.email || '') + '"></div><div class="dbd-err" role="alert"></div>' +
        '<button class="dbd-btn" type="submit">' + esc(C.tEmailBtn) + '</button></form><p class="dbd-legal">' + esc(C.tEmailLegal) + '</p>';
      var em = $('#dbd-email'); setTimeout(function () { em.focus(); }, 30);
      $('.dbd-form', step).addEventListener('submit', function (e) {
        e.preventDefault(); var val = em.value.trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(val)) { em.parentNode.classList.add('bad'); $('.dbd-err', step).textContent = C.tEmailErr; return; }
        S.email = val; klSubscribe(val, null);
        klProfile(val, { drop_offer: label(o), drop_visitor: ret ? 'returning' : 'first', drop_stage: 'email' });
        if (C.smsEnabled && !(ret && C.returningSkipSms)) { S.stage = 'sms'; } else { claim('email-only'); }
        save(); renderStep();
      });
    } else if (S.stage === 'sms') {
      var allowSkip = C.skipMode !== 'never';
      if (hold) {
        step.innerHTML = head + '<div class="dbd-hold"><h3>' + fill(esc(C.tHoldHead), { offer: esc(v.offer) }) + '</h3><p class="dbd-kick">' + esc(C.tHoldKick) + '</p>' + btn('dbd-back', C.tHoldBtn) +
          (allowSkip ? '<button class="dbd-link dbd-small" id="dbd-skip" type="button">' + esc(C.tHoldSkip) + '</button>' : '') + '<button class="dbd-link dbd-small" id="dbd-leave" type="button">' + esc(C.tHoldLeave) + '</button></div>';
        $('#dbd-back').addEventListener('click', function () { hold = false; if (C.skipMode === 'delayed') skipShown = true; renderStep(); });
        $('#dbd-leave').addEventListener('click', function () { hold = false; save(); closePop(); });
        if (allowSkip) $('#dbd-skip').addEventListener('click', function () { hold = false; claim('email-only'); renderStep(); });
        return;
      }
      var showSkip = allowSkip && (C.skipMode === 'always' || skipShown);
      step.innerHTML = head + '<h2 class="dbd-h" id="dbd-h">' + esc(C.tSmsHead) + '</h2><p class="dbd-kick">' + esc(C.tSmsKick) + '</p>' +
        '<form class="dbd-form" novalidate><div class="dbd-field"><span class="dbd-cc">US +1</span><input id="dbd-phone" type="tel" inputmode="tel" autocomplete="tel-national" placeholder="(555) 555-5555" aria-label="Mobile number"></div><div class="dbd-err" role="alert"></div>' +
        '<button class="dbd-btn" type="submit">' + esc(C.tSmsBtn) + '</button></form>' +
        '<button class="dbd-link dbd-small" id="dbd-skip" type="button"' + (showSkip ? '' : ' hidden') + '>' + esc(C.tSmsSkip) + '</button><p class="dbd-legal">' + esc(C.tSmsLegal) + '</p>';
      var ph = $('#dbd-phone'); setTimeout(function () { ph.focus(); }, 30);
      function fmt(d) { return d.length < 4 ? d : d.length < 7 ? '(' + d.slice(0, 3) + ') ' + d.slice(3) : '(' + d.slice(0, 3) + ') ' + d.slice(3, 6) + '-' + d.slice(6, 10); }
      ph.addEventListener('input', function () { var d = ph.value.replace(/\D/g, '').replace(/^1(?=\d{10})/, '').slice(0, 10); ph.value = fmt(d); clearTimeout(skipTimer); });
      $('.dbd-form', step).addEventListener('submit', function (e) {
        e.preventDefault(); var d = ph.value.replace(/\D/g, '').slice(0, 10);
        if (d.length !== 10) { ph.parentNode.classList.add('bad'); $('.dbd-err', step).textContent = C.tSmsErr; return; }
        clearTimeout(skipTimer); klSubscribe(S.email, '+1' + d); S.phone = true; claim('sms'); renderStep();
      });
      $('#dbd-skip').addEventListener('click', function () { clearTimeout(skipTimer); claim('email-only'); renderStep(); });
      clearTimeout(skipTimer);
      if (allowSkip && !showSkip && C.skipMode === 'delayed') skipTimer = setTimeout(function () { var b = $('#dbd-skip'); if (b && S.stage === 'sms' && !hold) { b.hidden = false; skipShown = true; } }, (C.skipDelay || 6) * 1000);
    } else if (S.stage === 'reveal') {
      var code = String(o.tiers[0][2]).toUpperCase(), personal = UNIQUE && S.offer === 'first', t1 = o.tiers[0], t2 = o.tiers[1];
      var vv = { amount: money(t1[1]), min: money(t1[0]), next: t2 ? money(t2[1]) : '', nextmin: t2 ? money(t2[0]) : '', where: S.phone ? C.tWherePhone : C.tWhereEmail };
      step.innerHTML = head + '<h2 class="dbd-h dbd-two" id="dbd-h">' + fill(esc(C.tRevealHead), { offer: '<span class="dbd-amt">' + esc(v.offer) + '</span>' }) + '</h2>' +
        (personal ? '<p class="dbd-sub">' + esc(fill(C.tRevealSubUnique, vv)) + '</p>' + (t2 ? '<p class="dbd-kick dbd-bump">' + esc(fill(C.tRevealBump, vv)) + '</p>' : '') +
          '<div class="dbd-tag dbd-pending"><code>' + esc(fill(C.tCodePending, vv)) + '</code></div>'
          : '<p class="dbd-sub"><b>' + esc(label(o)) + '</b>. ' + esc(S.phone ? C.tRevealSubSms : C.tRevealSub) + '</p>' +
          '<div class="dbd-tag"><code>' + esc(o.tiers.length > 1 ? o.tiers.map(function (t) { return t[2]; }).join(' / ') : code) + '</code><button class="dbd-copy" type="button">Copy</button></div>') + btn('dbd-start', C.tRevealBtn);
      if ($('.dbd-copy', step)) $('.dbd-copy', step).addEventListener('click', function (e) { var b = e.currentTarget; var txt = code; (navigator.clipboard ? navigator.clipboard.writeText(txt) : Promise.reject()).then(function () { b.textContent = 'Copied'; }, function () { b.textContent = txt; }); });
      $('#dbd-start').addEventListener('click', function () { closePop(); });
    }
  }
  function drop() {
    var go = $('#dbd-go'); go.disabled = true; go.textContent = '…';
    if (!S.offer) S.offer = isReturning && C.returningEnabled ? (Math.random() * 100 < (C.r2Odds || 20) ? 'r2' : 'r1') : 'first';
    var want = top(O(S.offer)), slots = []; SLOTS.forEach(function (v, j) { if (v === want) slots.push(j); });
    var target = slots.length ? slots[Math.floor(Math.random() * slots.length)] : 3;
    board.play(target, function () { go.textContent = fill(C.tWon, { offer: disp(O(S.offer)) }); setTimeout(function () { S.stage = 'email'; save(); renderStep(); }, 900); });
  }
  function claim(via) {
    var o = O(S.offer || 'first');
    S.claimed = true; S.claimedAt = S.claimedAt || Date.now(); S.stage = 'reveal'; S.mini = false; save();
    lastLevel = (unlocked(o, cart.sub) || [0, 0])[1];
    var personal = UNIQUE && S.offer === 'first', code = personal ? 'personal (Klaviyo)' : String(o.tiers[0][2]);
    klProfile(S.email, { drop_code: personal ? o.tiers.slice(1).map(function (t) { return t[2]; }).join(' / ') : o.tiers.map(function (t) { return t[2]; }).join(' / '), drop_offer: label(o), drop_expires: new Date(S.claimedAt + (C.validHours || 72) * 36e5).toISOString(), drop_visitor: S.offer === 'first' ? 'first' : 'returning', drop_stage: 'claimed', drop_sms: !!S.phone });
    klEvent('Drop Claimed', S.email, { offer: label(o), code: code, via: via });
    if (!DESIGN && !personal) fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart.js', { credentials: 'same-origin' }).catch(function () {}).then(refreshCart);
    setKlaviyoHidden(true);
  }

  // ---------- ticket ----------
  function left() { return Math.max(0, (S.claimedAt || Date.now()) + (C.validHours || 72) * 36e5 - Date.now()); }
  function fmtLeft(ms) { var d = Math.floor(ms / DAY), h = Math.floor(ms % DAY / 36e5), m = Math.floor(ms % 36e5 / 6e4); return d ? d + 'd ' + h + 'h ' + m + 'm' : h + 'h ' + m + 'm'; }
  function ticketHTML(t) {
    var o = O(t.offer), u = unlocked(o, t.cart), nx = nextTier(o, t.cart), first = o.tiers[0], soon = t.left < DAY;
    var target = nx ? nx[0] : o.tiers[o.tiers.length - 1][0], pct = !nx ? 100 : Math.min(100, t.cart / target * 100);
    var code = codeFor(u || first), pending = !code;
    var msg = (u && pending) ? fill(C.tTicketNeedCode, { amount: money(u[1]), gap: nx ? moneyExact(nx[0] - t.cart) : '', next: nx ? money(nx[1]) : '' }).replace(/\s+\.$/, '.')
      : !u ? fill(C.tTicketLocked, { gap: moneyExact(first[0] - t.cart), amount: money(first[1]) })
      : nx ? fill(C.tTicketPartial, { amount: money(u[1]), gap: moneyExact(nx[0] - t.cart), next: money(nx[1]) })
        : fill(C.tTicketFull, { amount: money(u[1]) });
    var big = u ? u[1] : first[1], st = u ? 'ok' : '';
    var terms = o.tiers.map(function (x) { return o.tiers.length > 1 ? money(x[1]) + ' at ' + money(x[0]) : money(x[0]) + '+'; }).join(' · ');
    if (t.mini) return '<button class="dbd-chip ' + st + (soon ? ' soon' : '') + '" data-act="expand" type="button" aria-label="Show your reward">' + money(big) + ' off' + (u ? ' · unlocked' : soon ? ' · ends ' + fmtLeft(t.left) : '') + '</button>';
    return '<div class="dbd-ticket ' + st + (soon ? ' soon' : '') + '" role="status" aria-live="polite" tabindex="0" data-act="toggle" aria-expanded="' + (!!t.open) + '">' +
      '<div class="dbd-amtb"><div><b>' + money(big) + '</b><small>OFF</small></div></div><div class="dbd-body">' +
      '<div class="dbd-ttop"><strong>' + esc(msg) + '</strong><button class="dbd-tmin" data-act="mini" type="button" aria-label="Minimize reward">Hide</button></div>' +
      '<div class="dbd-bar" aria-hidden="true"><i style="width:' + pct + '%"></i></div>' +
      '<div class="dbd-tcode">' + (pending ? '<span>' + esc(C.tCodeInTexts) + '</span><button data-act="toggle-code" type="button">' + esc(C.tEnterCode) + '</button>' : '<span>' + esc(code) + '</span><button data-act="copy" data-code="' + esc(code) + '" type="button">Copy</button>') + '<span class="dbd-exp">' + esc(terms) + (C.showCountdown ? ' · ' + (soon ? '<b>ends in ' + fmtLeft(t.left) + '</b>' : 'ends in ' + fmtLeft(t.left)) : '') + '</span></div></div></div>';
  }
  // Small card shown while a sticky Add to Cart bar is up: just the amount + a two-word status. Tap to see the full ticket.
  function compactHTML() {
    var o = O(S.offer), u = unlocked(o, cart.sub), nx = nextTier(o, cart.sub), first = o.tiers[0], soon = left() < DAY;
    var big = u ? u[1] : first[1], pending = u && !codeFor(u);
    var txt = pending ? C.tCompactCode
      : !u ? fill(C.tCompactLocked, { gap: moneyExact(first[0] - cart.sub), amount: money(first[1]) })
      : nx ? fill(C.tCompactPartial, { gap: moneyExact(nx[0] - cart.sub), next: money(nx[1]) })
        : C.tCompactFull;
    return '<button class="dbd-ticket dbd-compact ' + (u ? 'ok' : '') + (soon ? ' soon' : '') + '" data-act="peek" type="button" aria-label="Show your reward">' +
      '<span class="dbd-amtb"><span><b>' + money(big) + '</b><small>OFF</small></span></span><span class="dbd-body"><strong>' + esc(txt) + '</strong></span></button>';
  }
  function mysteryHTML(text) {
    return '<div class="dbd-mystery"><button class="dbd-mystery-open" data-act="reopen" type="button">' + esc(text) + '</button><button class="dbd-mystery-x" data-act="dismiss-chip" type="button" aria-label="Dismiss">×</button></div>';
  }
  function chipAllowed() { return !S.chipDismissedAt || (S.closedAt || 0) > S.chipDismissedAt; }
  function drawerHTML() {
    var o = O(S.offer), nx = nextTier(o, cart.sub), u = unlocked(o, cart.sub);
    var title = nx ? fill(C.tDrawerHead, { gap: moneyExact(nx[0] - cart.sub), next: money(nx[1]) }) : fill(C.tDrawerFull, { amount: money(u ? u[1] : top(o)) });
    var gap = nx ? nx[0] - cart.sub : 0;
    var list = (C.suggestions || []).filter(function (p) { return p.available; }).map(function (p) { return { p: p, score: !nx ? p.price : p.price >= gap ? p.price - gap : 1000 + gap - p.price }; })
      .sort(function (a, b) { return a.score - b.score; }).slice(0, 3);
    var entry = (UNIQUE && S.offer === 'first' && !S.uniqueCode) ? '<form class="dbd-codeform" data-act="noop"><label for="dbd-code-in">' + esc(C.tHaveCode) + '</label><div><input id="dbd-code-in" autocomplete="off" autocapitalize="characters" placeholder="' + esc(PREFIX || 'CODE') + '…"><button type="submit">Apply</button></div><small class="dbd-codeerr" role="alert"></small></form>' : '';
    if (!list.length && !entry) return '';
    return '<div class="dbd-drawer" role="dialog" aria-label="Ways to use your code">' + entry + '<h4>' + esc(title) + '</h4>' + list.map(function (x) {
      var after = nx ? (x.p.price >= gap ? fill(C.tDrawerUnlocks, { next: money(nx[1]) }) : moneyExact(gap - x.p.price) + ' to go after') : '';
      return '<div class="dbd-sug"><a class="dbd-sim" href="' + esc(x.p.url) + '">' + (x.p.image ? '<img src="' + esc(x.p.image) + '" alt="" loading="lazy">' : '') + '</a><div><a href="' + esc(x.p.url) + '">' + esc(x.p.title) + '</a> · ' + moneyExact(x.p.price) + (after ? '<small>' + esc(after) + '</small>' : '') + '</div><button type="button" data-act="add" data-variant="' + x.p.variant + '">+ Add</button></div>';
    }).join('') + '<button class="dbd-dclose" data-act="close-drawer" type="button">Close</button></div>';
  }
  // Hide our floating pieces whenever something covers the page: a theme <dialog>, an app's cart drawer, a menu, another popup.
  var overlayBaseline = null;
  function fixedCover(el) {
    for (var n = el; n && n !== document.body && n !== document.documentElement; n = n.parentElement) {
      var cs = getComputedStyle(n); if (cs.position !== 'fixed') continue;
      var r = n.getBoundingClientRect();
      return (r.height >= innerHeight * 0.7 && r.width >= Math.min(innerWidth * 0.8, 300) && +cs.opacity > 0.05) ? n : null;
    }
    return null;
  }
  function overlayOpen() {
    if (document.querySelector('dialog[open]')) return true;
    var W = innerWidth, H = innerHeight, pts = [[W / 2, H / 2], [W * 0.85, H / 2], [W * 0.15, H / 2]], found = [];
    pts.forEach(function (p) {
      var els = document.elementsFromPoint(p[0], p[1]);
      for (var i = 0; i < els.length; i++) { if (root.contains(els[i])) continue; var c = fixedCover(els[i]); if (c) found.push(c); break; }
    });
    if (overlayBaseline === null) { overlayBaseline = found; return false; } // ignore anything that's always on screen
    return found.some(function (c) { return overlayBaseline.indexOf(c) < 0; });
  }
  function checkOverlay() {
    if (DESIGN) return;
    var on = overlayOpen();
    if (on !== root.classList.contains('dbd-dlg')) root.classList.toggle('dbd-dlg', on);
  }
  function renderFloat() {
    if (!C.ticketEnabled) { floatEl.innerHTML = ''; return; }
    var html = '', chipsOk = !onExcluded && chipAllowed();
    if (pop) html = '';
    else if (S.claimed && left() > 0) {
      if (isCartPage) html = '';
      else if (stuck && !peek) html = compactHTML();
      else html = ticketHTML({ offer: S.offer, cart: cart.sub, left: left(), mini: S.mini && !peek, open: drawerOpen }) + (drawerOpen && !(S.mini && !peek) && C.drawerEnabled ? drawerHTML() : '');
    } else if (!S.claimed && S.stage && S.stage !== 'teaser' && S.offer && chipsOk) {
      html = mysteryHTML(fill(C.tChipFinish, { offer: disp(O(S.offer)) }));
    } else if (!S.claimed && S.teaserClosedAt && chipsOk && C.chipAfterClose) {
      html = mysteryHTML(C.tChipTeaser);
    }
    floatEl.innerHTML = html;
    var dr = $('.dbd-drawer', floatEl), tk = $('.dbd-ticket', floatEl);
    if (dr && tk) dr.style.bottom = 'calc(var(--dbd-offset) + ' + (tk.offsetHeight + (innerWidth >= 750 ? 34 : 22)) + 'px)';
    if (justUnlocked) { justUnlocked = false; var el = $('.dbd-ticket,.dbd-chip', floatEl); if (el) el.classList.add('dbd-pulse'); if (C.confetti) confetti(); }
    updateOffset();
  }
  floatEl.addEventListener('click', function (e) {
    var a = e.target.closest('[data-act]'); if (!a) return;
    var act = a.getAttribute('data-act');
    if (act === 'toggle') { if (e.target.closest('button,a') && e.target.closest('button,a') !== a) return; if (!C.drawerEnabled) return; drawerOpen = !drawerOpen; renderFloat(); }
    else if (act === 'mini') { e.stopPropagation(); drawerOpen = false; if (stuck && peek) { peek = false; } else { S.mini = true; save(); } renderFloat(); }
    else if (act === 'expand') { S.mini = false; save(); renderFloat(); }
    else if (act === 'peek') { peek = true; renderFloat(); }
    else if (act === 'dismiss-chip') { e.stopPropagation(); S.chipDismissedAt = Date.now(); save(); renderFloat(); }
    else if (act === 'copy') { e.stopPropagation(); var c = a.getAttribute('data-code'); (navigator.clipboard ? navigator.clipboard.writeText(c) : Promise.reject()).then(function () { a.textContent = 'Copied'; }, function () { a.textContent = c; }); }
    else if (act === 'close-drawer') { drawerOpen = false; renderFloat(); }
    else if (act === 'toggle-code') { e.stopPropagation(); drawerOpen = true; renderFloat(); var i = $('#dbd-code-in'); if (i) i.focus(); }
    else if (act === 'reopen') { openPop(S.stage && S.stage !== 'reveal' ? S.stage : 'teaser'); }
    else if (act === 'add') {
      e.stopPropagation(); a.disabled = true; a.textContent = 'Adding…';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +a.getAttribute('data-variant'), quantity: 1 }] }) })
        .then(function () { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); return refreshCart(); })
        .catch(function () { a.textContent = 'Try again'; a.disabled = false; });
    }
  });
  floatEl.addEventListener('submit', function (e) {
    var f = e.target.closest('.dbd-codeform'); if (!f) return; e.preventDefault();
    var val = String($('#dbd-code-in', f).value || '').trim().toUpperCase(), err = $('.dbd-codeerr', f); if (!val) return;
    var others = cart.codes.filter(function (c) { return !isMine(c); });
    selfUpdate++;
    fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: others.concat([val]).join(',') }) })
      .then(function (r) { return r.json(); }).then(function (c) {
        var ok = (c.discount_codes || []).some(function (d) { return String(d.code).toUpperCase() === val; });
        if (ok) { S.uniqueCode = val; save(); readCart(c); drawerOpen = false; syncCode(); render(); } else { err.textContent = C.tCodeErr; }
      }).catch(function () { err.textContent = C.tCodeErr; }).then(function () { selfUpdate--; });
  });
  floatEl.addEventListener('keydown', function (e) { if ((e.key === 'Enter' || e.key === ' ') && e.target.classList.contains('dbd-ticket')) { e.preventDefault(); drawerOpen = !drawerOpen; renderFloat(); } });

  // Sit above the sticky Add to Cart bar (and anything else fixed to the bottom that we're told about)
  // Uses the bar's final size (offsetHeight ignores its slide-in transform) the moment it starts showing, not mid-fade.
  var vars_ = {};
  function setVar(k, v) { if (vars_[k] !== v) { vars_[k] = v; root.style.setProperty(k, v); } } // only write on change, so we don't wake our own observer
  function updateOffset() {
    var off = 0;
    stickyBars().forEach(function (bar) { if (barShown(bar)) off = Math.max(off, bar.offsetHeight + parseFloat(getComputedStyle(bar).bottom || 0)); });
    setVar('--dbd-offset', Math.round(off) + 'px');
    var right = 12;
    if (!DESIGN && innerWidth < 750) {
      [30, 60, 90].forEach(function (dy) {
        for (var i = 5; i <= 9; i++) {
          var els = document.elementsFromPoint(innerWidth * i / 10, innerHeight - off - dy);
          for (var k = 0; k < els.length; k++) {
            if (root.contains(els[k])) continue;
            for (var n = els[k]; n && n !== document.body && n !== document.documentElement; n = n.parentElement) {
              var cs = getComputedStyle(n); if (cs.position !== 'fixed') continue;
              var r = n.getBoundingClientRect();
              if (r.width < innerWidth * 0.5 && r.height < 220 && r.left > innerWidth * 0.4 && !n.classList.contains('dbd-tucked')) right = Math.max(right, innerWidth - r.left + 8);
              break;
            }
            break;
          }
        }
      });
    }
    setVar('--dbd-right', Math.round(right) + 'px');
    var now = off > 0 || forceStuck;
    if (now !== stuck) { stuck = now; if (!stuck) peek = false; if (S.claimed) renderFloat(); }
  }
  // Re-check shortly after, too: a bar that fades in still reads as hidden on the very first frame.
  var raf = 0, follow = 0;
  function onScroll() {
    clearTimeout(follow); follow = setTimeout(function () { updateOffset(); checkOverlay(); }, 90);
    if (raf) return; raf = requestAnimationFrame(function () { raf = 0; updateOffset(); checkOverlay(); });
  }
  document.addEventListener('transitionrun', onScroll, true);
  addEventListener('scroll', onScroll, { passive: true }); addEventListener('resize', onScroll);
  document.addEventListener('transitionend', onScroll, true);
  document.addEventListener('click', function () { setTimeout(onScroll, 60); setTimeout(onScroll, 450); }, true);
  new MutationObserver(onScroll).observe(document.body, { attributes: true, childList: true, subtree: true, attributeFilter: ['class', 'open', 'style', 'hidden', 'aria-hidden'] });
  if (!DESIGN) setInterval(onScroll, 1000);

  // ---------- product page line + cart summary line ----------
  function pdpLine() {
    if (!C.pdpLine || !isProduct || !S.claimed || left() <= 0 || !C.productPrice) return;
    var anchor = document.querySelector(C.pdpAnchor || 'product-price'); if (!anchor) return;
    var el = document.getElementById('dbd-pdp'); if (!el) { el = document.createElement('div'); el.id = 'dbd-pdp'; el.className = 'dbd-pdp'; anchor.insertAdjacentElement('afterend', el); }
    var o = O(S.offer), nx = nextTier(o, cart.sub), u = unlocked(o, cart.sub), price = C.productPrice;
    if (!nx) { el.innerHTML = fill(esc(C.tPdpFull), { amount: '<b>' + money(u[1]) + '</b>' }); return; }
    var n = Math.max(1, Math.ceil((nx[0] - cart.sub - 0.001) / price));
    el.innerHTML = (u ? fill(esc(C.tPdpHave), { amount: '<b>' + money(u[1]) + '</b>' }) + ' ' : '') + fill(esc(n === 1 ? C.tPdpAddThis : C.tPdpAddN), { n: n, next: '<b>' + money(nx[1]) + '</b>' });
  }
  function cartLines() {
    if (!S.claimed || left() <= 0 || !C.cartLine) return;
    var o = O(S.offer), nx = nextTier(o, cart.sub), u = unlocked(o, cart.sub), first = o.tiers[0];
    var code = codeFor(u || first) || C.tYourCode;
    var html = !u ? '<b>' + esc(fill(C.tCartLocked, { code: code })) + '</b><span>' + esc(fill(C.tCartLockedSub, { gap: moneyExact(first[0] - cart.sub), amount: money(first[1]) })) + '</span><div class="dbd-bar"><i style="width:' + Math.min(100, cart.sub / first[0] * 100) + '%"></i></div>'
      : nx ? '<b>' + esc(fill(C.tCartApplied, { code: code, amount: money(u[1]) })) + '</b><span>' + esc(fill(C.tCartNext, { gap: moneyExact(nx[0] - cart.sub), next: money(nx[1]) })) + '</span><div class="dbd-bar"><i style="width:' + Math.min(100, cart.sub / nx[0] * 100) + '%"></i></div>'
        : '<b>' + esc(fill(C.tCartApplied, { code: code, amount: money(u[1]) })) + '</b><span>' + esc(fill(C.tCartFull, { amount: money(u[1]) })) + '</span>';
    document.querySelectorAll(C.cartAnchor || '.cart__summary-totals').forEach(function (a) {
      var prev = a.previousElementSibling, el = prev && prev.classList.contains('dbd-cartline') ? prev : null;
      if (!el) { el = document.createElement('div'); el.className = 'dbd-cartline'; a.insertAdjacentElement('beforebegin', el); }
      if (el.innerHTML !== html) el.innerHTML = html;
    });
  }
  if (C.cartLine) new MutationObserver(function () { if (S.claimed && document.querySelector(C.cartAnchor || '.cart__summary-totals') && !document.querySelector('.dbd-cartline')) cartLines(); }).observe(document.body, { childList: true, subtree: true });

  // ---------- confetti ----------
  function confetti() {
    if (reduceMotion()) return;
    var c = document.createElement('canvas'); c.className = 'dbd-confetti'; var W = innerWidth, H = innerHeight; c.width = W * 2; c.height = H * 2; root.appendChild(c);
    var ctx = c.getContext('2d'); ctx.scale(2, 2);
    var cols = [C.accent, C.btnBg, C.btnBorder, C.slotColor2, C.okColor, C.ink];
    var ps = []; for (var i = 0; i < 80; i++) ps.push({ x: W * 0.3 + Math.random() * W * 0.4, y: H - 140, vx: (Math.random() - 0.5) * 8, vy: -7 - Math.random() * 8, r: Math.random() * 6.28, vr: (Math.random() - 0.5) * 0.3, w: 5 + Math.random() * 5, c: cols[Math.floor(Math.random() * cols.length)] });
    var t0 = performance.now();
    (function f(t) { var k = (t - t0) / 1000; ctx.clearRect(0, 0, W, H); ps.forEach(function (q) { q.vy += 0.35; q.x += q.vx; q.y += q.vy; q.r += q.vr; ctx.save(); ctx.globalAlpha = Math.max(0, 1 - k / 1.6); ctx.translate(q.x, q.y); ctx.rotate(q.r); ctx.fillStyle = q.c; ctx.fillRect(-q.w / 2, -q.w / 4, q.w, q.w / 2); ctx.restore(); }); if (k < 1.6) requestAnimationFrame(f); else c.remove(); })(t0);
  }

  // ---------- cart changes ----------
  function onCart() {
    if (S.claimed) {
      var lvl = unlocked(O(S.offer), cart.sub); var key = lvl ? lvl[1] : 0;
      if (lastLevel !== null && key > lastLevel) justUnlocked = true;
      lastLevel = key; syncCode();
    }
    render();
  }
  function render() { renderFloat(); pdpLine(); cartLines(); }

  // ---------- preview in the theme editor ----------
  if (PREVIEW !== 'off') {
    var st = { teaser: ['teaser'], email: ['email'], sms: ['sms'], hold: ['sms', 1], reveal: ['reveal'] }[PREVIEW];
    S = { offer: 'first', email: 'you@example.com', claimed: false };
    if (PREVIEW === 'mystery') { S.teaserClosedAt = S.closedAt = Date.now(); render(); return; }
    if (st) { S.stage = st[0]; hold = !!st[1]; if (PREVIEW === 'reveal') { S.claimed = true; S.claimedAt = Date.now(); } openPop(S.stage); return; }
    S.claimed = true; S.claimedAt = Date.now(); S.stage = 'reveal';
    var o = O('first'), t2 = o.tiers[o.tiers.length - 1];
    cart.sub = { 'ticket-locked': 0, 'ticket-close': Math.max(0, o.tiers[0][0] - 5.05), 'ticket-partial': o.tiers[0][0] + 9.9, 'ticket-full': t2[0] + 14.85, 'ticket-soon': Math.max(0, o.tiers[0][0] - 5.05), 'chip': Math.max(0, o.tiers[0][0] - 5.05), 'drawer': Math.max(0, o.tiers[0][0] - 5.05) }[PREVIEW] || 0;
    if (PREVIEW === 'ticket-soon') S.claimedAt = Date.now() - ((C.validHours || 72) * 36e5) + 5 * 36e5;
    if (PREVIEW === 'chip') S.mini = true;
    if (PREVIEW === 'drawer') drawerOpen = true;
    if (PREVIEW === 'compact') { cart.sub = o.tiers[0][0] + 9.9; forceStuck = true; }
    render(); return;
  }

  // ---------- start ----------
  if (S.claimed) setKlaviyoHidden(true);
  refreshCart().then(function () {
    if (S.claimed) lastLevel = (unlocked(O(S.offer), cart.sub) || [0, 0])[1];
    if (S.claimed && left() <= 0) { S.expired = true; }
    render();
    if (S.claimed || onExcluded) return;
    if (C.testMode) { maybeTrigger(); return; }
    if (isReturning) {
      if (!C.returningEnabled) return;
      if (S.returningShownAt && Date.now() - S.returningShownAt < (C.returningCooldown || 60) * DAY) return;
    } else {
      if (C.skipKnown && klaviyoKnown() && !S.stage) return;
    }
    if (S.teaserClosedAt && Date.now() - S.teaserClosedAt < (C.closeCooldown || 7) * DAY) return;
    if (S.stage && S.stage !== 'teaser') return; // mid-flow: chip invites them back
    maybeTrigger();
  });
  function maybeTrigger() {
    var mobile = innerWidth < 750; if ((mobile && !C.showMobile) || (!mobile && !C.showDesktop)) return;
    var fired = false;
    function fire() { if (fired || pop) return; fired = true; removeEventListener('scroll', sc); if (isReturning) S.returningShownAt = Date.now(); save(); openPop('teaser'); }
    function sc() { var h = document.documentElement; var p = (h.scrollTop) / Math.max(1, h.scrollHeight - innerHeight) * 100; if (C.scrollPct > 0 && p >= C.scrollPct) fire(); }
    setTimeout(fire, (C.delay || 8) * 1000); addEventListener('scroll', sc, { passive: true });
    if (!mobile && C.exitIntent) document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY <= 0) fire(); });
  }
  setInterval(function () { if (S.claimed) render(); }, 30000);
})();
